export enum AssociationType {
    Parent = 1,
    Child = 2,
    None = 3
}